/* GUBOSA Premium: small presentation enhancements; no third-party requests. */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const isSpanish = () => document.documentElement.lang.toLowerCase().startsWith('es');
  const hiddenClass = 'gp-float-hidden';
  function improveCopy(scope = document) {
    if (!isSpanish()) return;
    const labels = new Map([['Marine','Náutica'],['Marina','Náutica'],['Cleaners','Limpiadores'],['Contact','Contacto'],['Company','Sobre GUBOSA'],['Weight:','Formato:'],['Weight','Formato'],['Size:','Diámetro:'],['Size','Diámetro'],['Share','Compartir'],['Our Reviews','Opiniones']]);
    scope.querySelectorAll('header, .menu-drawer, .footer, cart-notification, .cart-item, .product-option, .product__info-container, pickup-availability-drawer, .shopify-section-group-header-group').forEach(container => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement && ['SCRIPT','STYLE','TEXTAREA','INPUT'].includes(node.parentElement.tagName)) continue;
        const value = node.nodeValue.trim();
        if (labels.has(value)) node.nodeValue = node.nodeValue.replace(value, labels.get(value));
      }
    });
    scope.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;
      if (href.includes('gubosa.proyectosdesarrollosweb.com/sobre-nosotros') || href.endsWith('#company')) { link.href = root + '#gubosa-fabrica'; if (link.textContent.trim() === 'Nosotros' || link.textContent.trim() === 'Company') link.textContent = 'Sobre GUBOSA'; }
      if (href.includes('gubosa.proyectosdesarrollosweb.com/blog')) { link.href = root + '#gp-guia'; link.textContent = 'Guía de elección'; }
      if (href.startsWith('https://hgd62d-ta.myshopify.com/pages/')) link.setAttribute('href', href.replace('https://hgd62d-ta.myshopify.com', ''));
    });
  }
  function tidyReviews() {
    document.querySelectorAll('#AirReviews-BlockWrapper').forEach(el => {
      if (/SAMPLE\s+REVIEWS/i.test(el.textContent)) el.classList.add(hiddenClass);
    });
    document.querySelectorAll('#transcySwitcherContainer').forEach(el => el.classList.add(hiddenClass));
    document.querySelectorAll('[class*="AirReviews"], [class*="air-reviews"], [id*="AirReviews"]').forEach(el => {
      const style = getComputedStyle(el);
      if ((style.position === 'fixed' || style.position === 'sticky') && /Our Reviews|Opiniones/.test(el.textContent)) el.classList.add(hiddenClass);
    });
    document.querySelectorAll('[class*="AirReviews"], [class*="air-reviews"]').forEach(el => {
      const rating = el.getAttribute('data-rating') || el.getAttribute('data-average-rating');
      const count = el.getAttribute('data-review-count') || el.getAttribute('data-count');
      if (rating === '0' || rating === '0.0' || count === '0') el.classList.add(hiddenClass);
    });
  }
  const purposes = new Map([
    ['pulimento-para-plasticos-gb-295','Para el pulido de plásticos. Consulta las superficies compatibles.'],
    ['pulimento-de-alto-corte-gb-200-copia-1','Alto corte para corregir defectos profundos en pinturas curadas.'],
    ['pulimento-de-corte-rapido-2-en-1-gb-250-copia-1','Pulimento de corte rápido de la gama de automoción.'],
    ['pulimento-de-alto-brillo-gb-300-copia-1','El paso de alto brillo dentro de tu sistema de pulido.'],
    ['pulimento-para-super-brillo-antiholograma-gb-350-copia-1','Pulimento de acabado de la gama de automoción.'],
    ['metal-polish-100-ml-copia','Pulidor profesional para el cuidado y acabado de metales.'],
    ['microfibra-profesional-de-alto-rendimiento-pack-5-unidades','Pack de 5 unidades para completar tus trabajos de limpieza y acabado.']
  ]);
  function improveCards() {
    if (!isSpanish()) return;
    document.querySelectorAll('.card__information .card__heading a[href*="/products/"]').forEach(link => {
      const container = link.closest('.card__information');
      if (!container || container.querySelector('.gp-native-purpose')) return;
      const handle = new URL(link.href, location.origin).pathname.split('/').filter(Boolean).pop();
      const purpose = purposes.get(handle);
      if (!purpose) return;
      const paragraph = document.createElement('p');
      paragraph.className = 'gp-native-purpose';
      paragraph.textContent = purpose;
      link.closest('.card__heading').insertAdjacentElement('afterend', paragraph);
    });
  }
  function formatPrices() {
    if (!isSpanish() || (window.Shopify && Shopify.currency && Shopify.currency.active !== 'EUR')) return;
    document.querySelectorAll('.price, .gp-card-price').forEach(container => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement && ['SCRIPT','STYLE'].includes(node.parentElement.tagName)) continue;
        const next = node.nodeValue.replace(/A partir de\s*/g, 'Desde ').replace(/€\s*([\d.,]+)(?:\s*EUR)?/g, '$1 €');
        if (next !== node.nodeValue) node.nodeValue = next;
      }
    });
  }
  function initialize() { improveCopy(); tidyReviews(); improveCards(); formatPrices(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  // Review apps can mount after the initial document; inspect only added elements.
  const observer = new MutationObserver(records => {
    if (!records.some(r => r.addedNodes.length)) return;
    improveCopy(); tidyReviews(); improveCards(); formatPrices();
  });
  if (document.body) observer.observe(document.body, {childList:true,subtree:true});
})();


/* Surface-specific finish guide; native selects, no external requests. */
if (!customElements.get('gubosa-finish-guide')) {
  customElements.define('gubosa-finish-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.guideInitialized) return;
      const source = this.querySelector('[data-gp-guide-options]');
      if (!source) return;
      const options = JSON.parse(source.textContent);
      const surface = this.querySelector('[data-gp-surface]');
      const stage = this.querySelector('[data-gp-finish-stage]');
      const finish = this.querySelector('[data-gp-finish]');
      const result = this.querySelector('[data-gp-result]');
      const title = this.querySelector('[data-gp-result-title]');
      const description = this.querySelector('[data-gp-result-description]');
      const productLink = this.querySelector('[data-gp-product-link]');
      const accessoryLink = this.querySelector('[data-gp-accessory-link]');
      this.guideInitialized = true;
      surface.addEventListener('change', () => {
        const choices = Array.isArray(options[surface.value]) ? options[surface.value] : [];
        finish.replaceChildren(new Option(document.documentElement.lang.startsWith('es') ? 'Selecciona la fase de trabajo' : 'Select the polishing stage', ''));
        choices.forEach((choice, index) => finish.add(new Option(choice.label, String(index))));
        finish.disabled = !choices.length;
        stage.hidden = !choices.length;
        result.hidden = true;
      });
      finish.addEventListener('change', () => {
        const choices = options[surface.value];
        const choice = finish.value !== '' && Array.isArray(choices) ? choices[Number(finish.value)] : null;
        if (!choice) { result.hidden = true; return; }
        title.textContent = choice.title;
        description.textContent = choice.description;
        const languageRoot = window.Shopify?.routes?.root || '/';
        const localUrl = url => languageRoot !== '/' && url.startsWith('/') && !url.startsWith(languageRoot) ? languageRoot + url.slice(1) : url;
        productLink.href = localUrl(choice.url);
        const spanish = document.documentElement.lang.startsWith('es');
        productLink.textContent = choice.url === '/pages/industrial' ? (spanish ? 'Ver gama industrial →' : 'View industrial range →') : (spanish ? 'Ver pulimento →' : 'View compound →');
        accessoryLink.href = localUrl(choice.accessoryUrl);
        accessoryLink.textContent = choice.accessory + ' →';
        result.hidden = false;
      });
    }
  });
}

/* GUBOSA review 31-10: native product form and reference search. */
(() => {
  function normalizeReference(value) {
    return value.replace(/\bgb[\s-]?(\d{3,4})(?!\d)/gi, 'GB-$1');
  }
  document.addEventListener('input', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'q' || event.isComposing) return;
    const normalized = normalizeReference(input.value);
    if (normalized === input.value) return;
    const caret = input.selectionStart;
    const delta = normalized.length - input.value.length;
    input.value = normalized;
    if (caret !== null) input.setSelectionRange(caret + delta, caret + delta);
  }, true);
  document.addEventListener('submit', event => {
    const input = event.target.querySelector('input[name="q"]');
    if (input) input.value = normalizeReference(input.value);
  }, true);

  function addPadsNavigation() {
    const spanish = document.documentElement.lang.startsWith('es');
    const base = window.Shopify?.routes?.root || '/';
    document.querySelectorAll('.header__inline-menu > ul, .menu-drawer__navigation > ul').forEach(menu => {
      if (Array.from(menu.querySelectorAll('a')).some(a => a.getAttribute('href')?.includes('/collections/esponja'))) return;
      const mobile = !!menu.closest('.menu-drawer');
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = base + 'collections/esponja';
      link.className = mobile ? 'menu-drawer__menu-item list-menu__item link link--text focus-inset' : 'header__menu-item list-menu__item link link--text focus-inset';
      link.textContent = spanish ? 'Pads y accesorios' : 'Pads & accessories';
      item.append(link);
      menu.append(item);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addPadsNavigation, {once: true});
  else addPadsNavigation();
  document.addEventListener('shopify:section:load', addPadsNavigation);
})();

if (!customElements.get('gubosa-purchase-tools')) {
  customElements.define('gubosa-purchase-tools', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.info = this.closest('product-info');
      this.form = document.getElementById(this.dataset.formId);
      this.nativeButton = this.form?.querySelector('[name="add"]');
      this.bar = this.querySelector('[data-gp-purchase-bar]');
      this.button = this.querySelector('[data-gp-purchase-submit]');
      if (!this.info || !this.form || !this.nativeButton || !this.bar || !this.button) return;
      this.variants = JSON.parse(this.querySelector('[data-gp-purchase-variants]').textContent);
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.mainButtonVisible = false;
      this.update = () => {
        const id = this.form.querySelector('[name="id"]')?.value;
        const variant = this.variants[id];
        if (!variant) { this.bar.hidden = true; return; }
        const label = this.querySelector('[data-gp-purchase-variant]');
        const price = this.querySelector('[data-gp-purchase-price]');
        const property = this.form.querySelector('[data-gp-pack-property]');
        const note = this.querySelector('[data-gp-pack-note] b');
        if (label.textContent !== variant.label) label.textContent = variant.label === 'Default Title' ? '' : variant.label;
        const displayPrice = document.documentElement.lang.startsWith('es') ? variant.price.replace(/€\s*([\d.,]+)(?:\s*EUR)?/g, '$1 €') : variant.price;
        if (price.textContent !== displayPrice) price.textContent = displayPrice;
        if (property) {
          if (property.value !== variant.pack) property.value = variant.pack;
          if (property.disabled !== !variant.pack) property.disabled = !variant.pack;
        }
        if (note && note.textContent !== variant.pack) note.textContent = variant.pack;
        const disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
        this.button.disabled = disabled;
        const nativeLabel = this.nativeButton.querySelector('span')?.textContent.trim();
        if (nativeLabel && this.button.textContent !== nativeLabel) this.button.textContent = nativeLabel;
        this.bar.hidden = !this.mobile.matches || this.mainButtonVisible;
      };
      this.intersection = new IntersectionObserver(entries => {
        this.mainButtonVisible = entries[0].isIntersecting;
        this.update();
      }, {threshold: 0.5});
      this.intersection.observe(this.nativeButton);
      this.mutations = new MutationObserver(this.update);
      this.mutations.observe(this.form, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled','aria-disabled','value','class']});
      this.change = event => {
        if (event.target.name === 'id') this.update();
        else if (event.target.closest('variant-selects')) this.button.disabled = true;
      };
      this.info.addEventListener('change', this.change);
      this.mobile.addEventListener('change', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.intersection?.disconnect();
      this.mutations?.disconnect();
      this.info?.removeEventListener('change', this.change);
      this.mobile?.removeEventListener('change', this.update);
      this.ready = false;
    }
  });
}
